import FilterCard from "Components/Common/FilterBar/FilterCard/FilterCard";
import ToggleButton from "Components/Common/ToggleButton/ToggleButton";
import { RoleType } from "Models/Users/RoleType";
import React from "react";
import i18n from "Translations/i18n";

interface IProps {
    selectedRoles: RoleType[];
    onChange: (selectedRoles: RoleType[]) => void;
}

interface IState {
    
}

class RoleFilterCard extends React.Component<IProps, IState> {
    
    constructor(props: IProps) {
        super(props);

        this.state = {
        };

        this.getState = this.getState.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.clear = this.clear.bind(this);
    }

    public getState(role: RoleType): boolean {
        return this.props.selectedRoles.indexOf(role) !== -1;
    }

    public onToggle(role: RoleType, newState: boolean) {
        if(newState) {
            this.props.onChange([...this.props.selectedRoles, role]);                
        }
        else {
            const updated = [...this.props.selectedRoles];
            const index = updated.indexOf(role);
            if(index > -1) {
                updated.splice(index, 1);
                this.props.onChange(updated);
            }
        }
    }

    public clear() {
        this.props.onChange([]);
    }

    public render() {  
        
        return (
            <FilterCard title={i18n.t("authentication.role")} onClear={this.props.selectedRoles.length ? this.clear : undefined}>
                <ToggleButton onToggle={(newState) => this.onToggle(RoleType.basic, newState)} state={this.getState(RoleType.basic)}>
                    {i18n.t("authentication.roles.basic")}
                </ToggleButton>
                <ToggleButton onToggle={(newState) => this.onToggle(RoleType.shiftleader, newState)} state={this.getState(RoleType.shiftleader)}>
                    {i18n.t("authentication.roles.shift_leader")}
                </ToggleButton>
                <ToggleButton onToggle={(newState) => this.onToggle(RoleType.manager, newState)} state={this.getState(RoleType.manager)}>
                    {i18n.t("authentication.roles.manager")}
                </ToggleButton>
            </FilterCard>
        );
    }
}

export default RoleFilterCard;


// WEBPACK FOOTER //
// ./src/Components/Common/FilterBar/FilterCards/RoleFilterCard/RoleFilterCard.tsx